module.exports = __webpack_public_path__ + "img/dick2-cover-2.ee9c8d31.jpg";